export const {downloadContract} = {
    downloadContract: '/handlers/download-contract-note',
};
